module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_a-f80697d2f82400f9d744d091f6abdbf7.png";